import { NEW_REQUEST_PAGE } from "utils/reducers";

const initialState = {
  show: false,
};

const showNewRequestPageReducer = (state = initialState, action) => {
  switch (action.type) {
    case NEW_REQUEST_PAGE.display:
      return {
        ...state,
        show: true,
      };
    case NEW_REQUEST_PAGE.hide:
      return {
        ...state,
        show: false,
      };
    default:
      return state;
  }
};

export default showNewRequestPageReducer;
